import * as React from 'react';
import * as styles from '../Summary.desktop.css';
import { VisibleViolationsWarningContainer } from '../../VisibleViolationsWarning';
import { N1PublicationBannerContainer } from '../../N1PublicationBanner/N1PublicationBanner.container';
import { MLSNPublicationBannerContainer } from '../../MLSNPublicationBanner/MLSNPublicationBanner.container';
import { ServicePickerWidget } from '../../PublishTerms/components/ServicePickerWidget/ServicePickerWidget';
import { ActionButtonsContainer } from '../../ActionButtons';
import { SubagentNotEnoughMoneyModalContainer } from '../../SubagentNotEnoughMoneyModal';

export const SummaryDesktopServicePickerWidget = () => {
  return (
    <div className={styles['summary']}>
      <ServicePickerWidget />

      <N1PublicationBannerContainer />
      <MLSNPublicationBannerContainer />

      <div className={styles['checkout']}>
        <SubagentNotEnoughMoneyModalContainer />
        <VisibleViolationsWarningContainer />
        <div className={styles['actions']}>
          <div className={styles['actions-buttons']}>
            <ActionButtonsContainer />
          </div>
        </div>
      </div>
    </div>
  );
};
